module.exports = __webpack_public_path__ + "static/media/SearchGlass.a9e06b6f.svg";